
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/what-is-managed-transportation",
      function () {
        return require("private-next-pages/content/what-is-managed-transportation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/what-is-managed-transportation"])
      });
    }
  